<template>
	<div id="content_body">
		<!-- :instanceClass="instanceClassAttr.instanceClass" -->
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>

		<div class="container mt-n10">
			<div class="mt-5 bg-image-company">
				<div class="row mt-5 " v-if="isAuthorized(['RROLE_ADMIN','RROLE_MANAGER','RROLE_AGENT'])">
					<div class="col-xl-3 col-md-6 mb-4">
						<!-- Dashboard info widget 1-->
						<div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-primary h-100">
							<div class="card-body">
								<div class="d-flex align-items-center">
									<div class="flex-grow-1">
										<div class="small font-weight-bold text-primary mb-1">
											{{ $t('home.fileNumber') }}
										</div>
										<div class="h5">{{ indicators.nbCases.count || 0 }}</div>
										<div class="text-xs font-weight-bold text-success d-inline-flex align-items-center">
											<i class="mr-1" :data-feather="indicators.nbCases.trend"></i>
											{{ indicators.nbCases.tendency || 0 }}%
										</div>
									</div>
									<div class="ml-2">
										<fa icon="book" width="3em" class="text-gray-200" aria-hidden="true" />
										<!-- <font-awesome-icon :icon="['fa', 'book']" class="text-gray-200" size="3x" aria-hidden="true" /> -->
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-xl-3 col-md-6 mb-4">
						<!-- Dashboard info widget 2-->
						<div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-warning h-100">
							<div class="card-body">
								<div class="d-flex align-items-center">
									<div class="flex-grow-1">
										<div class="small font-weight-bold text-warning mb-1">
											{{ $t('home.nbFormal') }}
										</div>
										<div class="h5">
											{{ indicators.nbFormalities.count || 0 }}
										</div>
										<div class="text-xs font-weight-bold text-success d-inline-flex align-items-center">
											<i class="mr-1" :data-feather="indicators.nbFormalities.trend" />
											{{ indicators.nbFormalities.tendency || 0 }}%
										</div>
									</div>
									<div class="ml-2">
										<fa icon="list-ul" width="3em" class="text-gray-200" aria-hidden="true" />
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-xl-3 col-md-6 mb-4">
						<!-- Dashboard info widget 2-->
						<div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-dark h-100">
							<div class="card-body">
								<div class="d-flex align-items-center">
								<div class="flex-grow-1">
									<div class="small font-weight-bold text-dark mb-1">
										{{ $t('home.finishFormal') }}
									</div>
									<div class="h5">
										{{ indicators.finishedFormalities.count || 0 }}
									</div>
									<div class="text-xs font-weight-bold text-success d-inline-flex align-items-center">
										<i class="mr-1" :data-feather="indicators.finishedFormalities.trend"></i>
										{{ indicators.finishedFormalities.tendency || 0 }}%
									</div>
								</div>
								<div class="ml-2">
									<fa icon="tasks" width="3em" class="text-gray-200" aria-hidden="true" />
								</div>
							</div>
							</div>
						</div>
					</div>

					<div class="col-xl-3 col-md-6 mb-4">
						<!-- Dashboard info widget 2-->
						<div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-secondary h-100">
							<div class="card-body">
								<div class="d-flex align-items-center">
									<div class="flex-grow-1">
										<div class="small font-weight-bold text-secondary mb-1">
											{{ $t('home.prsNumber') }}
										</div>
										<div class="h5">{{ indicators.nbIndividuals.count || 0 }}</div>
										<div class="text-xs font-weight-bold text-success d-inline-flex align-items-center">
											<i class="mr-1" :data-feather="indicators.nbIndividuals.trend"></i>
											{{ indicators.nbIndividuals.tendency || 0 }}%
										</div>
									</div>
									<div class="ml-2">
										<fa icon="users" width="3em" class="text-gray-200" aria-hidden="true" />
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
				<!-- card-waves -->
				<!--<div class="card mb-4 mt-6">
					<div class="card-body p-5">
						<div class="row align-items-center justify-content-between">
							<div class="col">
								<h2 class="text-primary">
									{{ $t('home.welcome') }}, {{ this.$store.getters.username }}
								</h2>
								<p class="text-gray-700">
									{{$t('homepage.go')}}
								</p>
							</div> -->
							<!-- <div style="background-color: white; width: 100%;">
								<img width="100%" src="@/assets/img/company/mainbg-pastabella.jpeg" />
							</div> -->
							<!--<div style="background-color: white; width: 49%;">
								<img width="100%" src="@/assets/img/company/Logo-PASTA BELLA -NEW-R_OFF.png" />
							</div>
							<div style="background-color: white; width: 49%;">
								<img width="100%" src="@/assets/img/company/Logo-PASTA BELLA -NEW-B_OFF.png" />
							</div> 
							
						</div>

					</div>
				</div>-->

				
			</div>
	</div>
</div>
</template>

<script>
	import Header from '@/layouts/templates/Header.vue';
	import modalScriptMixin from "@/mixins/modalScriptMixin";
	// import { linkActivationMixin } from '@/mixins/linkActivationMixin'
	// import feather from "feather-icons"
	// import DosDossierListQuickView from '@/modules/dossier/views/DosDossierListQuickView';
	const appModules = process.env.VUE_APP_MODULES || ''
	/*import EventListQuickView from '@/modules/events/views/EventListQuickView';
	import PayPaymentListQuickView from '@/modules/payment/views/PayPaymentListQuickView';*/

	export default {
		name: 'home',
		mixins: [modalScriptMixin],
		components: {
			'header-layout': Header,
			/*'dossier-quickview': DosDossierListQuickView,
			'events-quickview': EventListQuickView,
			'payorders-quickview': PayPaymentListQuickView*/
		},
		// mixins: [linkActivationMixin],
		// props: ['stripeResponse', 'refBill'],
		data() {
			let _requestedIndicators = "nbUsers,nbIndividuals,nbCompanies,nbCases,nbFormalities,finishedFormalities"
			let _indicators = {}
			let reqSplitArray = _requestedIndicators.split(',')
			for (let j = 0; j < reqSplitArray.length; j++) {
				_indicators[reqSplitArray[j]] = {
					count: 0,
					tendency: 0
				}
			}
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-1',
				pageHeaderContainer: 'container',
				pageTitle: this.$t('home.list'),
				pageSubtitle: '',
				pageIcon: 'home',
				requestedIndicators: _requestedIndicators,
				indicators: _indicators,
				instanceClassAttr: {
					instanceClass: 'home'
				},
				personInfo: null,
				fieldsRecords: [
					{ key: 'id', label: 'Identifiant', sortable: true },
					{ key: 'name', label: 'Nom', sortable: false },
					{ key: 'date', label: 'Date', sortable: true }
				],
				fieldsMessages: [
					{ key: 'id', label: 'Identifiant', sortable: true },
					{ key: 'title', label: 'Titre', sortable: false },
					{ key: 'date', label: 'Date', sortable: true }
				],
				records: [
					{ id: 1, name: 'Procédure consultative', date: '02-12-2021' },
					{ id: 2, name: 'Procédure consultative', date: '02-10-2021' },
					{ id: 3, name: 'Procédure consultative', date: '12-11-2021' }
				],
				messages: [
					{ id: 1, title: 'Message d\'infos sur le dossier #1', date: '02-12-2021' },
					{ id: 2, title: 'Demande de documents', date: '02-10-2021' },
					{ id: 3, title: 'Acceptation de la demande', date: '12-11-2021' }
				],
				modules: appModules.split(',')
			}
		},
		created (){
			this.pageSubtitle = this.$t('home.label', { appName: this.$store.getters.appConfig.appName})
			// console.log(this.$store.getters.pageHeaderBg)
			/* if(this.isAuthorized(["ROLE_MANAGER", "ROLE_ADMIN", "ROLE_AGENT"]))
					this.getIndicators();*/ // A revoir
			// Get persons infos
			// this.getPersonInfos(); // A revoir
		},
		methods: {
			
			async getPersonInfos(){
				await this.$store.dispatch('axiosGetSingle', {
					domain: 'secuser',
					id: this.$store.getters.uid+'/linkedgisentity'
				})
				.then(response => {
					if(response)
						this.personInfo = response.data
					else
						this.personInfo = null
				})
				.catch(error => {
					this.personInfo = null
				})
			},
			async getIndicators(){
				await this.$store.dispatch('axiosPostPlainUrl', {
					url: '/api/statistik/indicators',
					data: {
						indicators: this.requestedIndicators, // All indicators wanted. It must existed in the backend
						tendencyTimeLapse: 7 // The number of days before this day to be used to calculate tendency
					}
				}).then(response => {
					let reqArray = this.requestedIndicators.split(',');
					let indics = {}
					if(response) {
						for (let i = 0; i < reqArray.length; i++) {
							const indic = reqArray[i];
							indics[indic] = response.data[indic]
							indics[indic].trend = (response.data[indic].tendency > 0) ? 'trending-up' : 'minus'
						}
						this.indicators = indics
					}

					this.$nextTick(()=> {
						// feather.replace();
						// console.log(this.indicators)
					})
				}).catch(error => {
					console.log('error catch == ', error.message)
				})
			},
			isAuthorized(auths) {
				if (this.$store.getters.roles){
					return auths.some(r => this.$store.getters.roles.includes(r))
				}
				return false;
			}
		}
	}
</script>

<style scoped >
	.size-18{
		width: 26px;
		height: 26px;
	}
	.bg-image-company {
		background-image: url('@/assets/img/company/actualProject/img-back-home.png');
		background-size: center; /*cover*/
		background-position: center center;
		background-repeat: no-repeat;
		height: 80vh; /*150vh*/
		width: auto;
		background-color: white;
	}
</style>